import { DialogSize } from '@wcg/frontend-framework';

export function createProcessingData(message: string) {
  return {
    title: 'Processing Request',
    additionalDescription: message,
    dialogSize: DialogSize.MEDIUM,
    buttonColor: '#083566',
    buttonTitle: 'Go to Downloads and Exports',
    cancelButtonTitle: 'Check for file later',
  };
}
